import React, { useState, useEffect } from "react";
import { Box, Button, getColor, Icons, Typography } from "fds";
import "../index.scss";
import useAppStore from "../../../redux/dispatcher/useAppStore";
import { PRODUCT_ITEM_TYPE } from "../../../redux/api/appApi";
import AppRegisterModal from "../../AppRegisterModal";
import { t } from "i18next";
import utilsCommon from "../../../shared/utils/common";

interface LinkAppTabProps {
  open: boolean;
}

export const PRODUCT_NAME = {
  zoom: "Zoom",
  outlook: "Outlook",
  googleDrive: "Google Drive",
  dropbox: "Dropbox",
} as { [key in PRODUCT_ITEM_TYPE]: string };

const LinkAppTab: React.FC<LinkAppTabProps> = ({ open }) => {
  /** hook정리 */
  const { appState, getAppLoginInfo } = useAppStore();

  /** State정리 */
  const [connectStatus, changeConnectStatus] = useState({
    zoom: false,
    googleDrive: false,
    dropbox: false,
  }); // 연결 확인 정보
  const [openLinkAppModal, toggleOpenLinkAppModal] = useState("CLOSE"); // 연동, 연동해제 모달

  /** useEffect 정리 */
  useEffect(() => {
    if (open) {
      getAppLoginInfo("zoom");
      if (window.eco.companyName === "linkApp") {
        // getAppLoginInfo('googleDrive');
        getAppLoginInfo("dropbox");
      }
    }
  }, [open]);
  useEffect(() => {
    changeConnectStatus({
      ...connectStatus,
      zoom: !!appState.appRegisterStatus && !!appState.appRegisterStatus.zoom,
      googleDrive:
        !!appState.appRegisterStatus &&
        !!appState.appRegisterStatus.googleDrive,
      dropbox:
        !!appState.appRegisterStatus && !!appState.appRegisterStatus.dropbox,
    });
  }, [appState.appRegisterStatus]);

  return (
    <Box classes="profileModal-body">
      {openLinkAppModal !== "CLOSE" && (
        <AppRegisterModal
          open={openLinkAppModal !== "CLOSE"}
          onClose={() => toggleOpenLinkAppModal("CLOSE")}
          handleAfter={() => toggleOpenLinkAppModal("CLOSE")}
          modalType={
            openLinkAppModal.includes("open") ? "CONNECT" : "UNCONNECT"
          }
          openLinkAppModal={openLinkAppModal}
        />
      )}
      <Typography type="subtitle2">{t("header.linkApp.connectApp")}</Typography>
      <Typography
        type="body4_rg"
        exactColor={getColor("COLOR_TEXT_SECONDARY")}
        classes="mg mt-4"
      >
        {t("header.linkApp.info")}
      </Typography>
      <Box classes="mg mt-20" direction="column">
        {utilsCommon.checkMenuAvailable("zoom") && (
          <Box width="100%" height={40} alignItems="center">
            <img
              src={require("../../../shared/images/common/zoom.png")}
              alt={"thumbnail"}
              width={40}
              height={40}
            />
            <Typography type="subtitle2" classes="mg ml-12">
              Zoom
            </Typography>
            <Button
              btnStyle="link"
              label={
                connectStatus.zoom
                  ? t("header.linkApp.disconnect")
                  : t("header.linkApp.connect")
              }
              size="lg"
              classes="mg ml-auto"
              type={connectStatus.zoom ? "error" : "primary"}
              onClick={() =>
                toggleOpenLinkAppModal(
                  connectStatus.zoom ? "close_zoom" : "open_zoom"
                )
              }
              leadingIcon={
                <Icons
                  variant="line"
                  label={connectStatus.zoom ? "exceptionCircle" : "plusCircle"}
                />
              }
            />
          </Box>
        )}
        {window.eco.companyName === "linkApp" && (
          <Box width="100%" height={40} alignItems="center" classes="mg mt-20">
            <img
              src={require("../../../shared/images/common/dropbox.png")}
              alt={"thumbnail"}
              width={40}
              height={40}
            />
            <Typography type="subtitle2" classes="mg ml-12">
              Dropbox
            </Typography>
            <Button
              btnStyle="link"
              label={
                connectStatus.dropbox
                  ? t("header.linkApp.disconnect")
                  : t("header.linkApp.connect")
              }
              size="lg"
              classes="mg ml-auto"
              type={connectStatus.dropbox ? "error" : "primary"}
              onClick={() =>
                toggleOpenLinkAppModal(
                  connectStatus.dropbox ? "close_dropbox" : "open_dropbox"
                )
              }
              leadingIcon={
                <Icons
                  variant="line"
                  label={
                    connectStatus.dropbox ? "exceptionCircle" : "plusCircle"
                  }
                />
              }
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LinkAppTab;
